import React from 'react';
import { Query } from 'react-apollo';

import queries from '../../graphql/queries';

import PageTitle from '../../components/shared/page-title';
import Feeds from '../../components/shared/feeds';
import TopicHeader from '../../components/topic/header';
import TopicTabs from '../../components/topic/tabs';
import TopicMain from '../../components/topic/main';

const {
  topicQueries: { TOPIC_BY_NAME },
} = queries;

function TopicPage(props) {
  const {
    match: {
      params: { topicName },
    },
  } = props;

  return (
    <>
      <PageTitle
        pageTitle={`Quora - ${topicName}`}
        pageDesc={`${topicName} topic page of Quora`}
      />
      <Feeds>
        <Query query={TOPIC_BY_NAME} variables={{ topicName }}>
          {({ loading, error, data }) => {
            if (loading) return <div>Loading...</div>;
            if (error) return <div>Error!</div>;

            const { topicByName } = data;

            return (
              <>
                <TopicHeader topic={topicByName} />
                <TopicTabs topicName={topicName} />
                <TopicMain topic={topicByName} />
              </>
            );
          }}
        </Query>
      </Feeds>
    </>
  );
}

export default TopicPage;
